var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCropCompare = function SvgCropCompare(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#a4a2a2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m2 7c0-.55228.44772-1 1-1h10c.5523 0 1 .44772 1 1s-.4477 1-1 1h-10c-.55228 0-1-.44772-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 11c0-.5523.44772-1 1-1h6c.55228 0 1 .4477 1 1s-.44772 1-1 1h-6c-.55228 0-1-.4477-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2 15c0-.5523.44772-1 1-1h6c.55228 0 1 .4477 1 1s-.44772 1-1 1h-6c-.55228 0-1-.4477-1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.2929 12.2929c-.3905.3905-.3905 1.0237 0 1.4142s1.0237.3905 1.4142 0l2-2c.3905-.3905.3905-1.0237 0-1.4142l-2-2.00001c-.3905-.39052-1.0237-.39052-1.4142 0-.3905.39053-.3905 1.02369 0 1.41422l.2929.29289h-5.5858c-.5523 0-1 .4477-1 1s.4477 1 1 1h5.5858z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.7071 15.7071c.3905-.3905.3905-1.0237 0-1.4142s-1.0237-.3905-1.4142 0l-2 2c-.3905.3905-.3905 1.0237 0 1.4142l2 2c.3905.3905 1.0237.3905 1.4142 0s.3905-1.0237 0-1.4142l-.2929-.2929h5.5858c.5523 0 1-.4477 1-1s-.4477-1-1-1h-5.5858z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCropCompare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/crop_compare.fecf5ca9.svg";
export { ForwardRef as ReactComponent };